import { ReactNode } from 'react'
import { useIsMobile } from '../../hooks/useBreakpoint'
import { cn } from '../../lib/utils'

export interface ListDetailProps {
  list: ReactNode
  detail?: ReactNode
  listWidth?: number
  showDetailOnMobile?: boolean
  emptyDetail?: ReactNode
  className?: string
}

export function ListDetail({ list, detail, listWidth = 340, showDetailOnMobile = false, emptyDetail, className }: ListDetailProps) {
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className={cn('min-h-0 flex-1 overflow-hidden', className)}>
        {showDetailOnMobile
          ? <div className="h-full overflow-y-auto">{detail ?? emptyDetail}</div>
          : <div className="h-full overflow-y-auto bg-card">{list}</div>}
      </div>
    )
  }

  return (
    <div className={cn('flex min-h-0 flex-1 overflow-hidden', className)}>
      <div className="shrink-0 overflow-y-auto border-r border-border bg-card" style={{ width: listWidth }}>
        {list}
      </div>
      <div className="min-w-0 flex-1 overflow-y-auto">{detail ?? emptyDetail}</div>
    </div>
  )
}
